/* Optispar Footer V1
   Small, idempotent accessibility enhancements for the draft theme.
   No observers, DOM reordering or external libraries. */
(function () {
  'use strict';

  if (window.__optisparFooterV1) return;
  window.__optisparFooterV1 = true;

  var FOOTER_SELECTOR = 'footer#shopify-section-sections--27918673478017__footer_WnX4aJ';
  var UTILITIES_SELECTOR = '#shopify-section-sections--27918673478017__utilities.footer-utilities';
  var PAYMENT_SELECTOR = '#shopify-section-sections--27918673478017__178195053540b38ccf';
  var POLICY_SELECTOR = '#terms-policies-popover.terms-policies-popover';

  function addClass(element, className) {
    if (element && !element.classList.contains(className)) element.classList.add(className);
  }

  function ensureNewsletter(footer) {
    var block = footer && footer.querySelector('.email-signup-block');
    var form = block && block.querySelector('.email-signup__form');
    var input = form && form.querySelector('input[type="email"]');
    var button = form && form.querySelector('.email-signup__button');
    if (!block || !form || !input || !button) return;

    var heading = block.querySelector('.email-signup__heading');
    if (heading && heading.textContent.trim() !== 'Newsletter abonnieren & 5 % sichern') {
      heading.textContent = 'Newsletter abonnieren & 5 % sichern';
    }
    var eyebrow = block.querySelector('.os-newsletter-eyebrow');
    if (!eyebrow) {
      eyebrow = document.createElement('div');
      eyebrow.className = 'os-newsletter-eyebrow';
      eyebrow.innerHTML = '<span class="os-newsletter-eyebrow__icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4.75 6.75h14.5v10.5H4.75V6.75Z" stroke="currentColor" stroke-width="1.7"/><path d="m5.5 7.5 6.5 5 6.5-5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>Optispar Newsletter</span>';
      block.insertBefore(eyebrow, heading || block.firstChild);
    }

    var copy = block.querySelector('.os-newsletter-copy');
    if (!copy) {
      copy = document.createElement('p');
      copy.className = 'os-newsletter-copy';
      copy.textContent = 'Angebote, Neuheiten und praktische Produkttipps direkt per E-Mail.';
      if (heading && heading.nextSibling) {
        block.insertBefore(copy, heading.nextSibling);
      } else if (heading) {
        block.appendChild(copy);
      } else {
        block.insertBefore(copy, form);
      }
    }

    if (!input.id) input.id = 'os-footer-email';
    input.autocomplete = 'email';
    input.required = true;
    input.placeholder = 'name@beispiel.de';

    var label = block.querySelector('.os-newsletter-label');
    if (!label) {
      label = document.createElement('label');
      label.className = 'os-newsletter-label';
      form.parentNode.insertBefore(label, form);
    }
    label.htmlFor = input.id;
    label.textContent = 'E-Mail-Adresse';

    if (button.textContent.trim() !== 'Jetzt abonnieren') {
      button.textContent = 'Jetzt abonnieren';
    }
    button.setAttribute('aria-label', 'Optispar Newsletter abonnieren');
    button.title = 'Jetzt abonnieren';

    var note = block.querySelector('.os-newsletter-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'os-newsletter-note';
      note.innerHTML = 'Jederzeit abmeldbar. Hinweise in unserer <a href="/policies/privacy-policy">Datenschutzerklärung</a>.';
      form.insertAdjacentElement('afterend', note);
    }

    form.setAttribute('aria-label', 'Optispar Newsletter anmelden');
  }

  function ensurePolicyPopover(popover) {
    if (!popover || popover.querySelector('.os-policy-header')) return;

    var header = document.createElement('div');
    header.className = 'os-policy-header';

    var title = document.createElement('strong');
    title.className = 'os-policy-title';
    title.textContent = 'Rechtliches & Einstellungen';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'os-policy-close';
    close.setAttribute('aria-label', 'Richtlinien schließen');
    close.setAttribute('popovertarget', popover.id);
    close.setAttribute('popovertargetaction', 'hide');
    close.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

    header.appendChild(title);
    header.appendChild(close);
    popover.insertBefore(header, popover.firstChild);
    popover.setAttribute('aria-label', 'Rechtliches und Einstellungen');
  }

  function enhancePaymentList(section) {
    if (!section) return;
    var iconList = section.querySelector('[class^="ai-payment-methods-icons-"], [class*=" ai-payment-methods-icons-"]');
    if (!iconList) return;

    var label = section.querySelector('.os-payment-label');
    if (label) label.remove();

    iconList.removeAttribute('aria-labelledby');
    iconList.setAttribute('role', 'group');
    iconList.setAttribute('aria-label', 'Akzeptierte Zahlungsarten');
  }

  function enhanceFooter() {
    var footer = document.querySelector(FOOTER_SELECTOR);
    var utilities = document.querySelector(UTILITIES_SELECTOR);
    var payment = document.querySelector(PAYMENT_SELECTOR);
    var policy = document.querySelector(POLICY_SELECTOR);

    addClass(footer, 'os-footer');
    addClass(utilities, 'os-footer-bottom');
    addClass(payment, 'os-footer-payments');
    ensureNewsletter(footer);
    ensurePolicyPopover(policy);
    enhancePaymentList(payment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceFooter, { once: true });
  } else {
    enhanceFooter();
  }

  document.addEventListener('shopify:section:load', enhanceFooter);
})();
